<template>
  <div v-show="isGradeViewActiveLocal">

    <div class="vx-row limit-width_fixed-scalable">
      <div class="vx-col mb-3" vs-lg="4" style="margin-top:8px">
        <span style="font-size: 18pt;font-weight: 100;color:white;">
          You have selected:
        </span>
      </div>

      <div class="vx-col" vs-lg="4" style="margin:auto">
        <vx-card class="glow-effect_dark limit-width_fixed card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="MessageCircleIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button size="large"
                        class="w-full button-text__left-align glow-effect_primary__hover back-button bg-color"
                        style="border-radius:0 7px 7px 0"
                        type="filled"
                        color=""
                        @click="backToPickLanguage">
              <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
              {{ selectedLanguage }}
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>

    <ul style="margin-top: 10px;flex-wrap: wrap;">
      <div class="limit-width_fixed-scalable" style="text-align: left;">
        <li>
          <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 277px">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_bg-color__blend bg-color">
                  <span><feather-icon class="pt-1" icon="BookmarkIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button :disabled="true"
                         size="large"
                         class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-lookalike text__school-tertiary-color bg-color"
                         type="filled"
                         color="">
                Select a Grade
              </vs-button>
            </vx-input-group>
          </vx-card>
        </li>
      </div>
      <li v-for="(_grade, gradeIndex) in grades" :key="gradeIndex" class="mb-4">
        <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="BookmarkIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button size="large"
                       class="w-full button__fully-opaque button-text__left-align glow-effect_primary school-primary_gradient"
                       style="border-radius:0 7px 7px 0;"
                       @click="selectGrade(_grade)">
              {{ _grade.name }}
            </vs-button>
          </vx-input-group>
        </vx-card>
      </li>
      <p v-show="showComingSoon" style="color:white;font-weight:500;font-size:16px;padding-top:5px">Watch this space! Content coming soon...</p>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    isGradeViewActive: {
      required: false,
    },
    selectedLanguage: {
      type: String,
      required: true
    },
    grades: {
      type: Array,
      required: false
    },
    showComingSoon: {
      required: false
    }
  },
  computed: {
    isGradeViewActiveLocal: {
      get() {
        return this.isGradeViewActive;
      }
    }
  },
  methods: {
    selectGrade(grade) {
      var self = this;
      self.$emit("gradeSelected", grade);
    },
    backToPickLanguage() {
      this.$emit("backToPickLanguage");
    }
  }
};
</script>
